import { activeModeType } from '@shared/store/ducks/customizer/customizer.type';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  root: {
    width: '418px',
    minHeight: '367px',
    padding: '30px',
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 10px 10px rgba(42, 53, 71, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.mode === activeModeType.dark ? theme.palette.extendedGrey?.lighter : '#DFE5EF'}`,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '16px',
  },
  logo: {},
  title: {
    fontSize: '21px',
    fontWeight: 700,
    lineHeight: '130%',
    color: '#2A3547',
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
    letterSpacing: '-0.02em',
    color: '#2A3547',
  },
  main: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
    width: '100%',
  },
  fieldLabel: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '140%',
    letterSpacing: '-0.01em',
    color: '#2A3547',
  },
  fieldInput: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      minHeight: '40px',
      borderRadius: '8px',
      backgroundColor: '#FFFFFF',
      '& fieldset': {
        borderColor: '#DFE5EF',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
      fontSize: '14px',
      lineHeight: '140%',
      letterSpacing: '-0.02em',
      color: '#2A3547',
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      fontSize: '16px',
      color: '#2A3547',
    },
    '& .MuiFormHelperText-root': {
      marginLeft: 0,
      marginRight: 0,
      marginTop: '4px',
      minHeight: '16px',
      fontSize: '12px',
      lineHeight: '140%',
      letterSpacing: '-0.02em',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: '#D92D20',
    },
    '& .MuiOutlinedInput-root.Mui-error fieldset': {
      borderColor: '#FDA29B',
    },
  },
  errorAlert: {
    marginTop: '4px',
    padding: '8px 12px',
    borderRadius: '8px',
    alignItems: 'flex-start',
    backgroundColor: '#FEF3F2',
    color: '#B42318',
    border: '1px solid #FECDCA',
    '& .MuiAlert-icon': {
      marginRight: '8px',
      padding: 0,
      opacity: 1,
    },
    '& .MuiAlert-message': {
      padding: 0,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '140%',
      letterSpacing: '-0.02em',
    },
  },
  errorIcon: {
    fontSize: '16px',
    color: '#F04438',
    marginTop: '1px',
  },
  forgotPasswordLink: {
    alignSelf: 'flex-end',
    marginTop: '-2px',
    color: '#1875FF',
    fontSize: '13px',
    lineHeight: '140%',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus-visible': {
      outline: '2px solid #1875FF',
      outlineOffset: '2px',
      borderRadius: '2px',
    },
  },
  ssoDivider: {
    margin: '2px 0',
    color: '#7C8FAC',
    fontSize: '12px',
    lineHeight: '140%',
    letterSpacing: '-0.02em',
    '&::before, &::after': {
      borderColor: '#DFE5EF',
    },
  },
  ssoButton: {
    width: '100%',
    height: '40px',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '140%',
    letterSpacing: '-0.02em',
  },
  login_btn: {
    width: '100%',
    '& .MuiButton-root': {
      height: '40px',
      borderRadius: '8px',
      backgroundColor: '#1875FF',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '140%',
      letterSpacing: '-0.02em',
      '&:hover': {
        backgroundColor: '#1875FF',
      },
    },
  },
}));
